import { Address, getContract, PublicClient, WalletClient } from 'viem';

import stakingTokenAbi from 'modules/api/abi/LiquidStakingToken';
import { LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';

export function getLiquidStakingTokenContract(
  client: WalletClient | PublicClient,
  poolAddress: Address = LIQUID_STAKING_TOKEN_ADDRESS,
) {
  return getContract({
    address: poolAddress,
    abi: stakingTokenAbi,
    client,
  });
}
